import {TransactionsRepositoriesFactory} from '../Repositories/factory.js'
import {GetLoanCalculationsB2CTransactionsService} from './GetLoanCalculationsB2CTransactionsService.js'

export default class TransactionsServicesFactory {
  static getLoanCalculationsB2CTransactionsService = ({config}) => {
    return new GetLoanCalculationsB2CTransactionsService({
      httpTransactionsRepository: TransactionsRepositoriesFactory.httpTransactionRepository({config})
    })
  }
}
